webpackJsonp([135866361011280],{

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavLink = __webpack_require__(12);
	
	var _NavLink2 = _interopRequireDefault(_NavLink);
	
	var _NavLinkPlaceholder = __webpack_require__(13);
	
	var _NavLinkPlaceholder2 = _interopRequireDefault(_NavLinkPlaceholder);
	
	__webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var children = props.children;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'docs-header', id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'lore-generate-generator'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Generates a new generator, which is a CLI command that generates other files.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'docs-content' },
	        _react2.default.createElement(
	          'ul',
	          { id: 'markdown-toc' },
	          _react2.default.createElement(_NavLink2.default, { title: 'Introduction', url: '/cli/lore-generate-generator/' })
	        ),
	        children
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreGenerateGenerator = __webpack_require__(295);
	
	var _LoreGenerateGenerator2 = _interopRequireDefault(_LoreGenerateGenerator);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreGenerateGenerator2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'generator'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'CLI command to create a new generator.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generate generator [generator-name]\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Example'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s say you want to create a new generator called ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-generate-example'
	      ),
	      '. To do that, you would run this command:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'sh', text: '\n      lore generator generator lore-generate-example\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This would create a new folder named ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-generate-example'
	      ),
	      ' and place all the files inside that reflect an basic generator. You can then register this generator in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '.lorerc'
	      ),
	      ' as a command while you develop it, and then (eventually, if you want) publish it to npm.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cli-lore-generate-generator-index-js-a727ad588d582d0838a8.js